export default "__VITE_ASSET__0cb84756__"